import React from 'react';
import { motion } from 'framer-motion';
import { Clock, FileText, Users, Banknote } from 'lucide-react';
const anim = (d: number = 0) => ({
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-40px'
  },
  transition: {
    duration: 0.3,
    delay: d,
    ease: 'easeOut' as const
  }
});
export function Problem() {
  const problems = [{
    icon: Clock,
    title: 'Empiezas dietas pero no las sigues',
    desc: 'Has probado planes de internet que no funcionan porque no encajan con tu vida real.'
  }, {
    icon: FileText,
    title: 'No sabes qué comer',
    desc: 'Cada día es la misma duda: ¿esto está bien? ¿esto engorda? ¿cuánto es demasiado?'
  }, {
    icon: Users,
    title: 'Necesitas ayuda profesional',
    desc: 'Sabes que un nutriólogo te ayudaría, pero ir a consulta presencial es complicado.'
  }, {
    icon: Banknote,
    title: 'Los nutriólogos son caros',
    desc: 'Las consultas privadas cuestan entre $800 y $2,000 MXN por sesión. Es difícil mantenerlo.'
  }];
  return <section className="bg-primary py-12 lg:py-20" data-id="element-183">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-[72px]" data-id="element-184">
        <div className="text-center mb-10 lg:mb-16" data-id="element-185">
          <h2 className="font-serif text-[28px] md:text-[42px] text-text-primary" data-id="element-186">
            ¿Te suena familiar?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-187">
          {problems.map((prob, idx) => <motion.div key={idx} {...anim(idx * 0.08)} className="bg-white rounded-2xl p-6 shadow-sm border border-text-primary/5 flex flex-col items-start" data-id="element-188">
              <prob.icon className="w-8 h-8 text-accent mb-4 stroke-[1.5]" data-id="element-189" />
              <h3 className="font-sans text-[16px] font-bold text-text-primary mb-2 leading-tight" data-id="element-190">
                {prob.title}
              </h3>
              <p className="font-sans text-[14px] font-light text-text-secondary leading-[1.6]" data-id="element-191">
                {prob.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div {...anim(0.3)} className="mt-12 text-center" data-id="element-192">
          <p className="font-serif italic text-[22px] md:text-[28px] text-accent" data-id="element-193">
            Por eso creamos FitConecta
          </p>
        </motion.div>
      </div>
    </section>;
}